const formatDate = (date: Date | undefined, isMobile = false, isSmall = false): string => {
  if (!date) return 'N/A';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    ...(isMobile ? {} : { year: 'numeric' }),
    ...(isSmall ? {} : { hour: '2-digit', minute: '2-digit' }),
  }).format(date);
};

export { formatDate };
